import {
  MODIFY_CAMPAIGN_HELP, MODIFY_CAMPAIGN_INFO, UPDATE_CAMPAIGN_INFO, MODIFY_CAMPAIGN_SOFTWARE,
  MODIFY_CAMPAIGN_CLASSIFICATION, MODIFY_CAMPAIGN_ATTACHMENTS, MODIFY_CAMPAIGN_VEHICLES,
  MODIFY_CAMPAIGN_RECIPIENTS, MODIFY_ORIGINAL_VALUES, MODYFY_CAMPAIGN, MODIFY_CAMPAIGN_HARDWARE, SET_VALIDATIONS,
  SET_CLASSIFICATION_VALIDATIONS, SET_RECIPIENTS_VALIDATIONS, SET_AFFECTED_VEHICLES_VOLUMES,
  MODIFY_AFFECTED_VEHICLES_SERIES, SET_AFFECTED_VEHICLES_VALIDATIONS, MODIFY_CAMPAIGN_SUMMARY, ADD_CAMPAIGN_ATTACHMENTS,
  DELETE_CAMPAIGN_ATTACHMENT, TOGGLE_ATTACHMENT_FAVORITE, UPDATE_ATTACHMENT_FIELD, ADD_AFTER_QMB_ATTACHMENTS,
  SET_CAMPAIGN_HISTORY, TOGGLE_CAMPAIGN_HISTORY, COPY_VEHICLES_MODEL_DESIGNATION, COPY_AGGREGATE, ADD_PLANT_ATTACHMENTS,
  ADD_SELECTED_PLANT, SET_ONLY_PLANTS, SET_SELECTED_AFFECTED_VEHICLES,
  SET_CAMPAIGN_TRANSLATIONS, SET_TRANSLATION_VALIDATIONS, SET_TRANSLATIONS, SET_ACTIVE_VALIDATIONS_MIN,
  SET_VOLUMES_AND_ORIGIN_CHANGE, MODIFY_CAMPAIGN_VEHICLES_ASSESSMENT, SET_AFFECTED_PLANTS, SET_SOFTWARE_VALIDATIONS,
  UPDATE_PLANT, DELETE_PLANT_ATTACHMENTS, COPY_PLANT_ATTACHMENTS, RESET_CAMPAIGN, SET_PENDING_VOLUMES,
  MODIFY_CAMPAIGN_PLANTFEEDBACK, SET_LIMITATION_PLANTS, SET_VEHICLE_GROUPS, SET_CAMPAIGN_CHANGES, SET_CAMPAIGN_SEARCH,
  SET_CAMPAIGN_SEARCH_SELECTED_COINCIDENCE_FIELD_ID, MODIFY_CAMPAIGN_DESCRIPTION, SET_DESCRIPTION_VALIDATIONS,
  MODIFY_CAMPAIGN_RISK_SCE_RELEVANCY, SET_HIGHLIGHT_TAB
} from '../types';

export const resetCampaign = () => ({
  type: RESET_CAMPAIGN,
  payload: null,
});

export const setCampaign = (campaign) => ({
  type: MODYFY_CAMPAIGN,
  payload: campaign,
});

export const setCampaignHelp = (help) => ({
  type: MODIFY_CAMPAIGN_HELP,
  payload: help,
});

export const setCampaignHistory = (history) => ({
  type: SET_CAMPAIGN_HISTORY,
  payload: history,
});

export const toggleCampaignHistory = (showHistory) => ({
  type: TOGGLE_CAMPAIGN_HISTORY,
  payload: showHistory,
});

export const setCampaignInfo = (info, fullReset = true) => ({
  type: fullReset ? MODIFY_CAMPAIGN_INFO : UPDATE_CAMPAIGN_INFO,
  payload: info,
});

export const setOriginalValues = (originalValues) => ({
  type: MODIFY_ORIGINAL_VALUES,
  payload: originalValues,
});

export const setCampaignDescription = (description) => ({
  type: MODIFY_CAMPAIGN_DESCRIPTION,
  payload: description,
});

export const setCampaignClassification = (classification) => ({
  type: MODIFY_CAMPAIGN_CLASSIFICATION,
  payload: classification,
});

export const setCampaignVehicles = (vehicles) => ({
  type: MODIFY_CAMPAIGN_VEHICLES,
  payload: vehicles,
});

export const setCampaignVehiclesTechAssessment = (techAssessment) => ({
  type: MODIFY_CAMPAIGN_VEHICLES_ASSESSMENT,
  payload: techAssessment,
});

export const setAffectedVehiclesSeries = (series) => ({
  type: MODIFY_AFFECTED_VEHICLES_SERIES,
  payload: series,
});

export const setCampaignSoftware = (software) => ({
  type: MODIFY_CAMPAIGN_SOFTWARE,
  payload: software,
});

export const setCampaignHardware = (hardware) => ({
  type: MODIFY_CAMPAIGN_HARDWARE,
  payload: hardware,
});

export const setCampaignRecipients = (recipients) => ({
  type: MODIFY_CAMPAIGN_RECIPIENTS,
  payload: recipients,
});

export const setCampaignRiskSCERelevancy = (riskPotentiallyRelevant) => ({
  type: MODIFY_CAMPAIGN_RISK_SCE_RELEVANCY,
  payload: riskPotentiallyRelevant,
});

export const setCampaignTranslations = (translations) => ({
  type: SET_CAMPAIGN_TRANSLATIONS,
  payload: translations,
});

export const setCampaignSummary = (summary) => ({
  type: MODIFY_CAMPAIGN_SUMMARY,
  payload: summary,
});

export const setCampaignAttachments = (attachments) => ({
  type: MODIFY_CAMPAIGN_ATTACHMENTS,
  payload: attachments,
});

export const addCampaignAttachments = (newAttachments) => ({
  type: ADD_CAMPAIGN_ATTACHMENTS,
  payload: newAttachments,
});

export const deleteCampaignAttachment = (attachmentId) => ({
  type: DELETE_CAMPAIGN_ATTACHMENT,
  payload: attachmentId,
});

export const toggleAttachmentFavorite = (attachmentId) => ({
  type: TOGGLE_ATTACHMENT_FAVORITE,
  payload: attachmentId,
});

export const updateAttachmentField = (attachmentId, changes) => ({
  type: UPDATE_ATTACHMENT_FIELD,
  payload: { attachmentId, changes },
});

export const addAfterQmbAttachments = (newAttachments) => ({
  type: ADD_AFTER_QMB_ATTACHMENTS,
  payload: newAttachments,
});

export const addPlantAttachments = (newAttachments) => ({
  type: ADD_PLANT_ATTACHMENTS,
  payload: newAttachments,
});

export const deletePlantAttachments = (wkz, file) => ({
  type: DELETE_PLANT_ATTACHMENTS,
  payload: { wkz, file },
});

export const copyPlantAttachments = (actionPayload) => ({
  type: COPY_PLANT_ATTACHMENTS,
  payload: actionPayload,
});

export const setDescriptionValidations = (validations) => ({
  type: SET_DESCRIPTION_VALIDATIONS,
  payload: validations,
});

export const setClassificationValidations = (validations) => ({
  type: SET_CLASSIFICATION_VALIDATIONS,
  payload: validations,
});

export const setSoftWareValidations = (validations) => ({
  type: SET_SOFTWARE_VALIDATIONS,
  payload: validations,
});

export const setRecipientValidations = (validations) => ({
  type: SET_RECIPIENTS_VALIDATIONS,
  payload: validations,
});

export const setTranslationValidations = (validations) => ({
  type: SET_TRANSLATION_VALIDATIONS,
  payload: validations,
});

export const setValidations = (validations) => ({
  type: SET_VALIDATIONS,
  payload: validations,
});

export const setMinActiveValidations = (label) => ({
  type: SET_ACTIVE_VALIDATIONS_MIN,
  payload: label,
});

export const setAffectedVehiclesVolumes = (volumes) => ({
  type: SET_AFFECTED_VEHICLES_VOLUMES,
  payload: volumes,
});

export const setVolumesAndOriginChanged = (volumes) => ({
  type: SET_VOLUMES_AND_ORIGIN_CHANGE,
  payload: volumes,
});

export const setVehicleGroups = (groupId, groups, plantSelected) => ({
  type: SET_VEHICLE_GROUPS,
  payload: { groupId, groups, plantSelected },
});

export const setAffectedVehiclesValidations = (volumesValidations) => ({
  type: SET_AFFECTED_VEHICLES_VALIDATIONS,
  payload: volumesValidations,
});

export const copyAffectedVehiclesModelDesignation = (modelDesignationCopy) => ({
  type: COPY_VEHICLES_MODEL_DESIGNATION,
  payload: modelDesignationCopy,
});

export const copyAffectedAggregate = (aggregateCopy) => ({
  type: COPY_AGGREGATE,
  payload: aggregateCopy,
});

export const addSelectedPlant = (selectedPlant) => ({
  type: ADD_SELECTED_PLANT,
  payload: selectedPlant,
});

export const setLimitationPlants = (plants) => ({
  type: SET_LIMITATION_PLANTS,
  payload: plants,
});

export const setAffectedPlants = (affectedPlants) => ({
  type: SET_AFFECTED_PLANTS,
  payload: affectedPlants,
});

export const updatePlant = (index, plant, hasChange = false) => ({
  type: UPDATE_PLANT,
  payload: { index, plant, hasChange },
});

export const setOnlyPlants = (onlyPlantsArray) => ({
  type: SET_ONLY_PLANTS,
  payload: onlyPlantsArray,
});

export const setCampaignVehiclesSelectedAffectedVehicles = (selectedAffectedVehicles) => ({
  type: SET_SELECTED_AFFECTED_VEHICLES,
  payload: selectedAffectedVehicles,
});

export const setTranslations = (translation) => ({
  type: SET_TRANSLATIONS,
  payload: translation,
});

export const setPendingVolumes = (arePending) => ({
  type: SET_PENDING_VOLUMES,
  payload: arePending,
});

export const setCampaignPlantFeedback = (plantFeedback) => ({
  type: MODIFY_CAMPAIGN_PLANTFEEDBACK,
  payload: plantFeedback,
});

export const setCampaignChanges = (campaignChanges) => ({
  type: SET_CAMPAIGN_CHANGES,
  payload: campaignChanges,
});

export const setCampaignSearch = (campaignSearch) => ({
  type: SET_CAMPAIGN_SEARCH,
  payload: campaignSearch,
});

export const setCampaignSearchSelectedCoincidendeFieldId = (field) => ({
  type: SET_CAMPAIGN_SEARCH_SELECTED_COINCIDENCE_FIELD_ID,
  payload: field,
});

export const setHighlightedTab = (field) => ({
  type: SET_HIGHLIGHT_TAB,
  payload: field,
});

